<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col sm="8" md="6" lg="5">
          <b-card-group>
            <b-card no-body class="p-sm-2 p-md-3">
              <b-card-body>
                <b-form @submit.prevent="login(form)" name="login">
                  <p v-show="isLoginFailed" class="text-danger">{{ $t('auth.failed') }}</p>
                  <template v-if="usePassword">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user" /></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input ref="email" v-model="form.email" type="email" class="form-control"
                        :placeholder="$t('global.email')" autocomplete="username-email" id="username-email" />
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text>
                          <i class="icon-lock" /></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input name="password" v-model="form.password" type="password" class="form-control"
                        :placeholder="$t('global.password')" autocomplete="current-password" id="current-password" />
                    </b-input-group>
                  </template>
                  <b-button-group class="d-flex mb-3" ref="submitButton">
                    <LanguagesDropdown />
                    <b-button v-if="usePassword" key="submit" type="submit" name="login" variant="primary"
                      :disabled="isLoading">
                      {{ $t('auth.login') }}
                    </b-button>
                    <b-button v-else type="button" variant="primary" @click="usePassword = true">
                      {{ $dt('auth.use_password', 'Use password') }}
                    </b-button>
                  </b-button-group>
                  <div id="google-btn" class="mb-2 d-flex justify-content-center" />
                </b-form>
                <b-row v-if="usePassword">
                  <b-col cols="12" sm="6">
                    <b-button variant="link" class="p-0" :to="{ name: 'Register' }">
                      {{ $t('auth.register_link') }}
                    </b-button>
                  </b-col>
                  <b-col cols="12" sm="6" class="text-sm-right">
                    <b-button variant="link" class="p-0" :to="{ name: 'PasswordForgot' }">
                      {{ $t('auth.forgot_password_link') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VT from '@/store/types';
import LanguagesDropdown from '@/containers/Dropdowns/LanguagesDropdown';

export default {
  components: { LanguagesDropdown },
  data() {
    return {
      form: {
        email: '',
        password: '',
        remember_name: navigator.userAgent,
      },
      usePassword: false,
      isLoading: false,
      isLoginFailed: false,
    };
  },
  mounted() {
    if (window.ENV.VUE_APP_OAUTH_GOOGLE_CLIENT_ID) {
      window.google.accounts.id.initialize({
        client_id: window.ENV.VUE_APP_OAUTH_GOOGLE_CLIENT_ID,
        callback: this.handleCredentialResponse
      });
      window.google.accounts.id.prompt();
      this.renderGoogleButton();
    }
    window.addEventListener('resize', this.renderGoogleButton);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.renderGoogleButton);
  },
  methods: {
    ...mapActions('Auth', { loginAction: VT.LOGIN }),
    renderGoogleButton() {
      window.google.accounts.id.renderButton(
        document.getElementById('google-btn'),
        { theme: 'outline', size: 'large', width: this.$refs.submitButton.clientWidth }
      );
    },
    login(data) {
      this.isLoginFailed = false;
      this.isLoading = true;
      this.loginAction(data).then(() => this.onLoginSuccess())
        .catch(() => { this.isLoginFailed = true; })
        .finally(() => { this.isLoading = false; });
    },
    handleCredentialResponse(response) {
      this.loginAction({
        provider: 'google',
        token: response.credential,
        remember_name: this.form.remember_name,
        oauth: true
      }).then(() => this.onLoginSuccess())
        .catch(() => { console.info('Oauth canceled or failed'); });
    },
    onLoginSuccess() {
      const redirectPath = sessionStorage.getItem('redirectPath');
      if (redirectPath) {
        sessionStorage.removeItem('redirectPath');
        this.$router.replace({ path: redirectPath });
      } else {
        this.$router.replace({ name: 'Dashboard' });
      }
    },
  }
};
</script>
